export default __webpack_public_path__ + "static/media/Group 626086.997edef2.svg";